import React, { useEffect, useRef, useState } from "react";
import useAvailableHeight from "../../Custom/UseAvailableHeight";
import QRCode from "qrcode.react";
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import UserDetailContext, {
  useUserDetailContext,
} from "../../UserDetailContext";
import { Link, useLocation } from "react-router-dom";
import defaultprofile from "../../../Assets/img/Default-Profile.jpg";
import { useDispatch, useSelector } from "react-redux";
import CryptoJS from "crypto-js";
import {
  getPersonalInfoReducer,
  getProfessionalInfoReducer,
} from "../../../Redux/Reducers/ProfileReducer";
const HomepageRightFeedd = ({ activeMenu }) => {
  const dispatch = useDispatch();
  const PersonalData = useSelector(
    (state) => state?.ProfileArray?.personalProfile?.data
  );
  const ProfessionalData = useSelector(
    (state) => state?.ProfileArray?.professionaProfile
  );

  const [availableHeight1, Column1Ref] = useAvailableHeight(155);
  const { userDetails } = useUserDetailContext();

  console.log("ONBOARDING DATA", userDetails);
  const percentage = 100;
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  let objectId = searchParams.get("objectId");
  const [profilePicturePersonal, setprofilePicturePersonal] = useState("");

  // const handleSharePortfolio = () => {
  //     updateShareProfileConfig({
  //         open: true,
  //         onClose: () => setShareProfileConfig((prev) => ({ ...prev, open: false })),
  //         qrCodeUrl: `${process.env.REACT_APP_CARD_URL}/portfolio?encryptedId=${encryptedUrlRef.current}&link=${objectId}`,
  //         showQr: false,
  //         profileType: "Portfolio",
  //     });
  // };

  const encryptedUrlRef = useRef("");

  useEffect(() => {
    if (PersonalData?.user_ref_id) {
      const encryptedId = CryptoJS.AES.encrypt(
        PersonalData?.user_ref_id?.toString(),
        "UserDetailsSecretKey"
      ).toString();
      encryptedUrlRef.current = encodeURIComponent(encryptedId);
      console.log("encrypted id ", encryptedUrlRef.current);
    }
  }, [PersonalData]);

  return (
    <>
      {activeMenu === "personal_profile" && (
        <>
          <div className="profile-box-1 mt-3">
            <p className="profile-content">Personal</p>
          </div>
          <div className="homepage-background-image rectangle-new">
            <div className="Qr-codeDesign-home flex-center">
              <QRCode
                className="container-gift-2"
                value={`${process.env.REACT_APP_CARD_URL}/profile?encryptedId=${encryptedUrlRef.current}`}
                style={{ height: "96px", width: "96px" }}
              />
            </div>
            <div className="profile-picture-homeOutline flex-center">
              <img
                className="cover-image"
                src={
                  PersonalData?.user_profile_url ||
                  userDetails?.proFile ||
                  `${defaultprofile}`
                }
                alt="personalCard_Image"
              />
            </div>
          </div>

          <div className="heading mt-5 pt-4">
            <h2 className="heading mt-2">{userDetails.name}</h2>
            {/* <span className="subheading">{userDetails.profession}</span> */}
            <p className="subheading">UID: {userDetails.uniqueId}</p>
          </div>

          <div className="heading-content home mx-3">
            <p>
              {/* Hello, I'm {userDetails.name}  UI/Visual Designer based in Bangalore. My professional journey has been marked by versatile roles in UI and Visual Design. */}
              {PersonalData?.about_me}
            </p>
          </div>

          <div className="my-profile-actions" style={{ marginBottom: "20px" }}>
            <div className="flex-center">
              <div className="probar">
                <CircularProgressbarWithChildren
                  value={percentage}
                  styles={buildStyles({
                    pathColor: `#FFA000`,
                    trailColor: `#FFDDA4`,
                    textColor: `#525252`,
                    textSize: `10px`,
                  })}
                >
                  <div style={{ fontSize: "10px", marginBottom: "5px" }}>
                    Status
                  </div>

                  <div style={{ fontSize: "10px", marginBottom: "5px" }}>
                    {percentage} %
                  </div>
                </CircularProgressbarWithChildren>
              </div>

              <div className="col probar-content">
                <h3 className="tit">Profile Completion</h3>
                <p className="tit-cont">
                  {percentage === 100 ? (
                    <>Well Done! Your Profile is completed.</>
                  ) : (
                    <>
                      Uh-oh! Looks like your profile and <br />{" "}
                      <u>
                        {/* <a href="#0">KYC</a> */}

                        <Link to="/countrySelecting">KYC </Link>
                      </u>{" "}
                      need some attention for a verified ID. To change the
                      border color when a card is clicked, you can use React
                      state to track the selected card. Here's how you can do
                      it:
                    </>
                  )}
                </p>
              </div>
            </div>
          </div>
          {/* </div> */}
        </>
      )}

      {activeMenu === "professional_profile" && (
        <>
          {/* <div className="homePage-section-one" ref={Column1Ref} style={{
                        minHeight: `${availableHeight1}px`,
                        display: "flex",
                        flexDirection: "column",
                        overflowY: "none"
                    }}> */}

          <div className="profile-box-1 mt-3">
            <p className="profile-content" style={{ marginLeft: 5 }}>
              Professional
            </p>
          </div>
          <div className="homepage-background-image rectangle-new">
            <div className="Qr-codeDesign-home flex-center">
              <QRCode
                className="container-gift-2"
                value={`${process.env.REACT_APP_CARD_URL}/profile?encryptedId=${encryptedUrlRef.current}`}
                style={{ height: "96px", width: "96px" }}
              />
            </div>
            <div className="profile-picture-homeOutline flex-center">
              <img
                className="cover-image"
                src={
                  ProfessionalData?.user_profile_url ||
                  userDetails?.proFile ||
                  `${defaultprofile}`
                }
                alt="personalCard_Image"
              />
            </div>
          </div>

          <div className="heading mt-5 pt-4">
            <h2 className="heading mt-2">{userDetails?.name}</h2>
            <span className="subheading">{ProfessionalData?.designation}</span>
            <p className="subheading">UID: {userDetails.uniqueId}</p>
          </div>

          <div className="heading-content home mx-3">
            <p>
              {ProfessionalData?.about_me}
              {/* Hello, I'm {userDetails.name}  UI/Visual Designer based in Bangalore. My professional journey has been marked by versatile roles in UI and Visual Design. */}
            </p>
          </div>

          <div className="my-profile-actions" style={{ marginBottom: "20px" }}>
            <div className="flex-center">
              <div className="probar">
                <CircularProgressbarWithChildren
                  value={percentage}
                  styles={buildStyles({
                    pathColor: `#FFA000`,
                    trailColor: `#FFDDA4`,
                    textColor: `#525252`,
                    textSize: `10px`,
                  })}
                >
                  <div style={{ fontSize: "10px", marginBottom: "5px" }}>
                    Status
                  </div>

                  <div style={{ fontSize: "10px", marginBottom: "5px" }}>
                    {percentage} %
                  </div>
                </CircularProgressbarWithChildren>
              </div>
              <div className="col probar-content">
                <h3 className="tit">Profile Completion</h3>
                <p className="tit-cont">
                  {percentage === 100 ? (
                    <>Well Done! Your Profile is completed.</>
                  ) : (
                    <>
                      Uh-oh! Looks like your profile and <br />{" "}
                      <u>
                        {/* <a href="#0">KYC</a> */}
                        <Link to="/countrySelecting">KYC </Link>
                      </u>{" "}
                      need some attention for a verified ID.
                    </>
                  )}
                </p>
              </div>
            </div>
          </div>
          {/* </div> */}
        </>
      )}

      {activeMenu === "financel" && (
        <>
          {/* <div className="homePage-section-one" ref={Column1Ref} style={{
                        minHeight: `${availableHeight1}px`,
                        display: "flex",
                        flexDirection: "column",
                        overflowY: "none"
                    }}> */}

          <div className="profile-box-1 mt-3">
            <p className="profile-content">Financial</p>
          </div>
          <div className="homepage-background-image rectangle-new">
            <div className="Qr-codeDesign-home flex-center">
              <QRCode
                className="container-gift-2"
                value={`${process.env.REACT_APP_CARD_URL}/digital-identity/Personal/${objectId}`}
                style={{ height: "96px", width: "96px" }}
              />
            </div>
            <div className="profile-picture-homeOutline flex-center">
              <img
                className="cover-image"
                src={
                  profilePicturePersonal ||
                  userDetails?.proFile ||
                  `${defaultprofile}`
                }
                alt="personalCard_Image"
              />
            </div>
          </div>

          <div className="heading mt-5 pt-4">
            <h2 className="heading mt-2">{userDetails.name}</h2>
            <span className="subheading">{userDetails.profession}</span>
            <p className="subheading">UID: {userDetails.uniqueId}</p>
          </div>

          <div className="heading-content home mx-3">
            <p>{PersonalData?.about_me}</p>
          </div>

          <div className="my-profile-actions" style={{ marginBottom: "20px" }}>
            <div className="flex-center">
              <div className="probar">
                <CircularProgressbarWithChildren
                  value={percentage}
                  styles={buildStyles({
                    pathColor: `#FFA000`,
                    trailColor: `#FFDDA4`,
                    textColor: `#525252`,
                    textSize: `10px`,
                  })}
                >
                  <div style={{ fontSize: "10px", marginBottom: "5px" }}>
                    Status
                  </div>

                  <div style={{ fontSize: "10px", marginBottom: "5px" }}>
                    {percentage} %
                  </div>
                </CircularProgressbarWithChildren>
              </div>
              <div className="col probar-content">
                <h3 className="tit">Profile Completion</h3>
                <p className="tit-cont">
                  {percentage === 100 ? (
                    <>Well Done! Your Profile is completed.</>
                  ) : (
                    <>
                      Uh-oh! Looks like your profile and <br />{" "}
                      <u>
                        {/* <a href="#0">KYC</a> */}
                        <Link to="/countrySelecting">KYC</Link>
                      </u>{" "}
                      need some attention for a verified ID.
                    </>
                  )}
                </p>
              </div>
            </div>
          </div>
          {/* </div> */}
        </>
      )}
    </>
  );
};
export default HomepageRightFeedd;
